<template>
  <div class="base-type-edit__free-note w-100">
    <div class="base-type-edit__free-note-title">
      <Icon icon="fa-pro-solid:sparkles" />
      Mehr Sichtbarkeit mit einem Premium-Paket
    </div>
    <p class="mb-0">
      Mit dem freien Paket sind Reichweite und Steuerung eingeschränkt.
      <router-link :to="{name: 'packages.index', query: routeQuery}" class="base-type-edit__free-link">
        Jetzt Paketoptionen ansehen
      </router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: 'FreePackageHint',
  props: {
    routeQuery: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
